import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdateComment($data: UpdateCommentInput!) {
    updateComment(data: $data) {
      id
    }
  }
`);

export interface UpdateGql {
  updateComment: {
    id: number;
  };
}
